import HeroBg from "public/ztna/heroBg.png";

export const HERO_CONSTANTS = {
  button: {
    label: "Request a Personalized Security Strategy Session ",
    link: "contact-us",
  },
  title: "ZTNA | VPN | Edge Firewall | SASE –\n Secure Network Access",
  desc: "Legacy security is outdated—Zero Trust is the future.OneMind ensures secure access for every user, device, and location.",
  image: HeroBg,
};
